import { Component } from '@angular/core';
import { SummaryGenrationParameterServiceService } from '../summary-genration-parameter-service.service';
import { Pagination } from 'src/app/core/pagination/pagination';
import { UrlConfigurationService } from 'src/app/configuration/url-configuration.service';
import { HeaderService } from 'src/app/core/header/header.service';
import { NotifierService, NotifierModule } from 'angular-notifier';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'src/app/core/core.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { StatusHandlerService } from 'src/app/core/services/status-handler.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmboxComponent } from 'src/app/core/confirmbox/confirmbox.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-manage-summary-generation-parameter',
  standalone: true,
  imports: [FormsModule, CommonModule, CoreModule, BsDropdownModule, NotifierModule,NgSelectModule],
  templateUrl: './manage-summary-generation-parameter.component.html',
  styleUrl: './manage-summary-generation-parameter.component.scss'
})
export class ManageSummaryGenerationParameterComponent {

  constructor(private SummaryGenrationParameterServiceService: SummaryGenrationParameterServiceService,
    private urlConfigurationService: UrlConfigurationService,
    private headerService: HeaderService,
    private notifierService: NotifierService,
    private errorHandler: ErrorHandlerService,
    private statusService: StatusHandlerService,
    private modalService: BsModalService

  ) {
    this.notifier = notifierService
  }
  briefGeniusList: any[] = [];
  newRows: any[] = [];
  filters = { jurisdiction: '', regulator: '', docType: '', createdOn: '' };
  totalPages: number = 0;
  public pagination: Pagination | any;
  public pagination1: Pagination | any;
  public showLoader: boolean = false;
  jurisdictionDropdown: any[] = [];
  regulatorDropdown: any[] = [];
  docTypeDropdown: any[] = [];
  public errorMessage: any = '';
  private readonly notifier: NotifierService;
  public wrapText: boolean = false;
  public currentPage: number | any;
  public columnValueList: any = null;
  public totalRecordsForPagination: number = 0
  bsModalRef!: BsModalRef;
  searchText: string = '';
  editRowIndex: number | null = null;
  editModel: any = {}; // temporary copy of row being edited
  editModelCopy: any = {};

  public columnDropdownFilter = [
    { id: 1, name: 'Is equal to', activeJurisdiction: false, activeRegulator: false, activeDocType: false },
    { id: 2, name: 'Is not equal to', activeJurisdiction: false, activeRegulator: false, activeDocType: false },
    { id: 3, name: 'Starts with', activeJurisdiction: false, activeRegulator: false, activeDocType: false },
    { id: 4, name: 'Contains', activeJurisdiction: false, activeRegulator: false, activeDocType: false },
    { id: 5, name: 'Does not contain', activeJurisdiction: false, activeRegulator: false, activeDocType: false },
    { id: 6, name: 'Ends with', activeJurisdiction: false, activeRegulator: false, activeDocType: false },
    { id: 7, name: 'Is null', activeJurisdiction: false, activeRegulator: false, activeDocType: false },
    { id: 8, name: 'Is not null', activeJurisdiction: false, activeRegulator: false, activeDocType: false },
  ];

  ngOnInit(): void {
    this.pagination = new Pagination();
    this.pagination.pageLength=100;
    // this.GetBriefGenius(this.pagination);
    this.LoadDropdowns();
  }

  // LoadDropdowns() {
  //   this.showLoader = true;
  //   // Load dropdown values from backend API
  //   // this.urlConfigurationService.GetDropdownValues().subscribe(res => {
  //   //   this.jurisdictionDropdown = res.jurisdictions;
  //   //   this.regulatorDropdown = res.regulators;
  //   //   this.docTypeDropdown = res.docTypes;
  //   // });
  //   this.GetJurisdictionOptions();
  //   this.GetRegulatorOptions(null);
  //   this.GetDocTypeOptions(null);
  //   this.showLoader = false;

  // }

  LoadDropdowns() {
  this.showLoader = true;

  let data = {
      ID: this.headerService.user.ClientMasterID
    }
  let Regdata = {
      JurisdictionIds: null
    }
   let DocTypedata = {
      ID: null, //Regulator Id
      RegulatorIds: null
    }
  forkJoin({
    jurisdictions: this.urlConfigurationService.GetJurisdictionOptions(data),
    regulators: this.urlConfigurationService.GetRegulatorOptions(Regdata),
    doctypes: this.urlConfigurationService.GetDocTypeOptions(DocTypedata)
  }).subscribe({
    next: (result:any) => {
      this.jurisdictionDropdown = result.jurisdictions.Data;
      this.regulatorDropdown = result.regulators.Data;
      this.docTypeDropdown = result.doctypes.Data;

      // After dropdowns finished loading → load table
      this.GetBriefGenius(this.pagination);

      // this.showLoader = false;
    },
    error: (err) => {
      // console.error("Failed to load dropdowns", err);
      this.notifier.notify('error', "Failed to load dropdowns");
      // this.showLoader = false;   // stop loader on error
    },
    complete: () => {
      // this.showLoader = false;  // always stop loader
    }
  });
}

  GetJurisdictionOptions() {
    // this.showLoader = true;
    let data = {
      ID: this.headerService.user.ClientMasterID
    }
    // this.showLoader = true;
    this.jurisdictionDropdown = [];
    this.urlConfigurationService.GetJurisdictionOptions(data).subscribe({
      next: (data: any) => {
        this.jurisdictionDropdown = data.Data;
        // this.showLoader = false;
      }, error: (error: any) => {
        // this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("URL Configuration", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  GetRegulatorOptions(ids: any) {
    let data = {
      JurisdictionIds: ids
    }
    // this.showLoader = true;
    this.regulatorDropdown = [];
    this.urlConfigurationService.GetRegulatorOptions(data).subscribe({
      next: (data: any) => {
        this.regulatorDropdown = data.Data;
        // this.showLoader = false;
      }, error: (error: any) => {
        // this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("URL Configuration", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  GetDocTypeOptions(ids: any) {
    let data = {
      ID: null, //Regulator Id
      RegulatorIds: ids
    }
    // this.showLoader = true;
    this.docTypeDropdown = [];
    this.urlConfigurationService.GetDocTypeOptions(data).subscribe({
      next: (data: any) => {
        this.docTypeDropdown = data.Data;
        // this.showLoader = false;
      }, error: (error: any) => {
        // this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("URL Configuration", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  GetBriefGenius(paginationdetail: any) {
    this.showLoader = true;
    if (paginationdetail) {
      this.pagination.pageIndex = paginationdetail.pageIndex;
      this.currentPage = this.pagination.pageIndex;
    }
    this.pagination.pageLength = this.pagination.pageLength;

    // const params = {
    //   pageNumber: page,
    //   pageLength: this.pagination.pageLength,
    //   sortColumn: this.pagination.columnName,
    //   sortOrder: this.pagination.ascending ? 'ASC' : 'DESC',
    //   filters: this.filters
    // };
    this.SummaryGenrationParameterServiceService.GetData(this.pagination).subscribe({
      next: (res: any) => {
        this.briefGeniusList = res.Data.Data;
        this.totalPages = res.Data.TotalPage;
        this.pagination.currentPage = res.Data.CurrentIndex;
        this.totalRecordsForPagination = res.Data.TotalRecordsForPagination;
        this.showLoader = false;
      }
    });
  }
  GetBriefGeniusByPageLength() {
    this.GetBriefGenius(this.pagination);
  }

  GetIncludedisabledRecords() {
    this.pagination.pageIndex = 1;
    this.GetBriefGenius(this.pagination);
  }

  SortColumn(column: string) {
    if (this.pagination.columnName === column) {
      this.pagination.ascending = !this.pagination.ascending;
    } else {
      this.pagination.columnName = column;
      this.pagination.ascending = true;
    }
    this.GetBriefGenius(this.pagination);
  }

  // SearchBriefGenius(column: string, index?: number) {
  //   this.pagination.currentPage = 1;
  //   this.GetBriefGenius(this.pagination);
  // }

  public searchString: string = '';
  SearchBriefGenius(column: string, index?: number) {
    this.pagination.currentPage = 1;

    if (index !== undefined) {
      this.handleFilterSelection(column, index);
    } else if (!this.hasActiveFilter(column)) {
      this.handleFilterSelection(column, 0);
    }

    this.buildSearchString();
    this.GetBriefGenius(this.pagination);
  }

  private handleFilterSelection(column: string, index: number) {
    this.resetActiveStates(column);
    this.setActiveState(column, index);
  }

  private getActiveProperty(column: string): 'activeJurisdiction' | 'activeRegulator' | 'activeDocType' {
    switch (column) {
      case 'Jurisdiction': return 'activeJurisdiction';
      case 'Regulator': return 'activeRegulator';
      case 'DocType': return 'activeDocType';
      default: return 'activeJurisdiction';
    }
  }

  private resetActiveStates(column: string) {
    const activeProperty = this.getActiveProperty(column);
    this.columnDropdownFilter.forEach(filter => {
      filter[activeProperty] = false;
    });
  }

  private setActiveState(column: string, index: number) {
    const activeProperty = this.getActiveProperty(column);
    this.columnDropdownFilter[index][activeProperty] = true;
  }

  private buildSearchString() {
    const searchParts: string[] = [];

    if (this.filters.jurisdiction) {
      const activeFilter = this.columnDropdownFilter.find(filter => filter.activeJurisdiction);
      if (activeFilter) {
        const searchPart = this.buildSearchPart('Jurisdiction', this.filters.jurisdiction, activeFilter.id);
        searchParts.push(searchPart);
      }
    }

    if (this.filters.regulator) {
      const activeFilter = this.columnDropdownFilter.find(filter => filter.activeRegulator);
      if (activeFilter) {
        const searchPart = this.buildSearchPart('Regulator', this.filters.regulator, activeFilter.id);
        searchParts.push(searchPart);
      }
    }

    if (this.filters.docType) {
      const activeFilter = this.columnDropdownFilter.find(filter => filter.activeDocType);
      if (activeFilter) {
        const searchPart = this.buildSearchPart('DocType', this.filters.docType, activeFilter.id);
        searchParts.push(searchPart);
      }
    }

    if (this.filters.createdOn) {
      const searchPart = this.buildDateSearchPart('CreatedOn', this.filters.createdOn);
      searchParts.push(searchPart);
    }

    this.searchString = searchParts.join('&');

    this.pagination.searchString = this.searchString;

    console.log('Search String:', this.searchString);
  }

  private buildSearchPart(column: string, value: string, filterType: number): string {
    return `${column}|${value},Flag|${filterType}`;
  }

  private buildDateSearchPart(column: string, dateValue: string): string {
    const formattedDate = this.formatDateForSearch(dateValue);
    return `${column}|${formattedDate},Flag|4`;
  }

  // Format date for search (convert to YYYY-MM-DD format)
  private formatDateForSearch(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD
  }

  AddNewRow() {
    this.LoadDropdowns();
    this.newRows.push({ JurisdictionId: null, RegulatorId: null, DocTypeId: null, CreatedOn: null });
  }

  RemoveNewRow(index: number) {
    this.newRows.splice(index, 1);
  }

  SaveNewRow(index: number) {
    this.showLoader = true;
    const row = this.newRows[index];

    if (row.JurisdictionID == null || row.RegulatorID == null || row.DocTypeID == null) {
      this.notifier.notify('warning', 'Please select Jurisdiction, Regulator and Doc Type.');
      this.showLoader = false;
      return;
    }

    this.SummaryGenrationParameterServiceService.Add(row).subscribe({
      next: (res: any) => {
        if (res.StatusCode == 200) {
          this.notifier.notify('success', 'Summary Generation Parameters saved successfully.');
          this.newRows.splice(index, 1);
          this.GetBriefGenius(this.pagination);
          this.showLoader = false;
        }
        else {
          this.showLoader = false;
          this.errorMessage = this.errorHandler.GetErrorMessage("Summary Parameter", res.StatusCode);
          this.notifier.notify('error', this.errorMessage);
        }
      },
      error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Summary Parameter", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  ShowConfirmBox(data: { StatusID: number; ID: number; }, isDelete: boolean) {
    let statusId;
    let tempStatusId;
    let message;
    if(isDelete){
      statusId=false;
      message="Are you sure you want to Disable Summary Parameter?";
      tempStatusId=2;
    }else{
      statusId=true;
      message="Are you sure you want to Enable Summary Parameter?"
      tempStatusId=1;
    }

    let initialState = { status: tempStatusId, id: data.ID, message: message };
    this.bsModalRef = this.modalService.show(ConfirmboxComponent, { initialState, ignoreBackdropClick: true, keyboard: false, class: 'modal-dialog-centered' });
    // this.bsModalRef.content.sendResponse.subscribe(this.ChangeStatus.bind(this));
    this.bsModalRef.content.sendResponse.subscribe((data: { status: any; id: any; }) => this.ChangeStatus(data));
  }

  ChangeStatus(status: { status: any; id: any; }) {
    let statusDetail = {
      IsActive: status.status == 2 ? false : true,
      ID: status.id
    }
    this.showLoader = true;
    this.SummaryGenrationParameterServiceService.ChangeStatus(statusDetail).subscribe({
      next: (data: any) => {
        this.showLoader = false;
        if (data.ErrorViewModel) {
          this.errorMessage = this.errorHandler.GetErrorMessage("Summary Parameter", data.ErrorViewModel.Code);
          this.notifier.notify('error', this.errorMessage);
          return;
        }
        else {
          if (statusDetail.IsActive == true) {
            this.notifier.notify('success', 'Summary Parameter enabled successfully.');
          }
          else if (statusDetail.IsActive == false) {
            this.notifier.notify('success', 'Summary Parameter disabled successfully.');
          }
          // && statusDetail.Status == 4
          if (this.briefGeniusList.length == 1 && this.pagination.pageIndex > 1) {
            this.pagination = new Pagination(this.pagination.columnName, this.pagination.ascending, this.pagination.pageIndex - 1);
            this.GetBriefGenius(this.pagination);
          }
          else {

            this.pagination = new Pagination(this.pagination.columnName, this.pagination.ascending, this.pagination.pageIndex);
            this.GetBriefGenius(this.pagination);
          }
        }
      },
      error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Summary Parameter", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

   GetSummaryParamDataToXLS(paginationdetail: any) {
    this.showLoader = true;

    if (paginationdetail) {
      this.pagination1 = new Pagination();
      this.pagination1.pageIndex = 1;
      this.currentPage = this.pagination1.pageIndex;
      this.pagination1.pageLength = -1;
      this.pagination1.clientMasterId = this.headerService.user.ClientMasterID;
      this.pagination1.isDeleted = true;
    }

    // this.pagination.pageLength = this.pagination.pageLength;

    this.SummaryGenrationParameterServiceService.GetSummaryParamDataToXLS(this.pagination1).subscribe({
      next: (data: any) => {
        this.showLoader = false;

        // Generate date-time string
        const now = new Date();
        const formattedDateTime = `${now.getFullYear()}${(now.getMonth() + 1)
          .toString()
          .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now
            .getHours()
            .toString()
            .padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now
              .getSeconds()
              .toString()
              .padStart(2, '0')}`;

        const fileName = `SummaryGenerationParameterList_${formattedDateTime}.xlsx`;

        if (window.navigator.msSaveOrOpenBlob) {
          var byteCharacters = atob(data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], { type: 'application/pdf' });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            window.open(objectUrl, fileName);
          }
        } else {
          var exportLink = document.createElement('a');
          exportLink.href = 'data:application/pdf;base64,' + encodeURI(data);
          exportLink.download = fileName;
          document.body.appendChild(exportLink);
          exportLink.click();
          document.body.removeChild(exportLink);
        }
      },
      error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage(
          'SummaryGenerationParamErrors',
          error.status
        );
      },
    });
  }

  editRow(i: number, row: any) {
    this.LoadDropdowns();
    this.editRowIndex = i;
    // this.editModel = { ...row }; // clone original row
    // // Deep clone object so UI changes do not affect original row
    // this.editModel = JSON.parse(JSON.stringify(row));
    this.editModel = {
      JurisdictionID: row.JurisdictionID,
      Jurisdiction: row.Jurisdiction,
      RegulatorID: row.RegulatorID,
      Regulator: row.Regulator,
      DocTypeID: row.DocTypeID,
      DocType: row.DocType
    };

    this.editModelCopy={
      JurisdictionID: row.JurisdictionID,
      Jurisdiction: row.Jurisdiction,
      RegulatorID: row.RegulatorID,
      Regulator: row.Regulator,
      DocTypeID: row.DocTypeID,
      DocType: row.DocType
    }
  }

  // saveRow(i: number) {
  //   // this.briefGeniusList[i] = { ...this.editModel };
  //   this.briefGeniusList[i] = { ...this.briefGeniusList[i], ...this.editModel };
  //   this.editRowIndex = null;
  // }
  saveRow(i: number) {
    this.showLoader = true;
    const selectedJurisdiction = this.jurisdictionDropdown.find(
      j => j.JurisdictionID === this.editModel.JurisdictionID
    );
    const selectedRegulator = this.regulatorDropdown.find(
      r => r.RegulatorID === this.editModel.RegulatorID
    );
    const selectedDocType = this.docTypeDropdown.find(
      d => d.DocTypeID === this.editModel.DocTypeID
    );

    this.briefGeniusList[i] = {
      ...this.briefGeniusList[i],
      JurisdictionID: this.editModel.JurisdictionID,
      Jurisdiction: selectedJurisdiction?.Jurisdiction || '',
      RegulatorID: this.editModel.RegulatorID,
      Regulator: selectedRegulator?.RegulatorName || '',
      DocTypeID: this.editModel.DocTypeID,
      DocType: selectedDocType?.DocTypeName || ''
    };

     this.SummaryGenrationParameterServiceService.Update(this.briefGeniusList[i]).subscribe({
      next: (res: any) => {
        if (res.StatusCode == 200) {
          this.notifier.notify('success', 'Summary Generation Parameters Updated successfully.');
          this.GetBriefGenius(this.pagination);
          this.showLoader = false;
        }
        else {
          this.editRowIndex = i;
          // this.editModel = { ...row }; // clone original row
          // // Deep clone object so UI changes do not affect original row
          // this.editModel = JSON.parse(JSON.stringify(row));
          this.editModel = {
            JurisdictionID: this.briefGeniusList[i].JurisdictionID,
            Jurisdiction: this.briefGeniusList[i].Jurisdiction,
            RegulatorID: this.briefGeniusList[i].RegulatorID,
            Regulator: this.briefGeniusList[i].Regulator,
            DocTypeID: this.briefGeniusList[i].DocTypeID,
            DocType: this.briefGeniusList[i].DocType
          };
          this.showLoader = false;
          this.errorMessage = this.errorHandler.GetErrorMessage("Summary Parameter", res.StatusCode);
          this.notifier.notify('error', this.errorMessage);
        }
      }
    });
    this.editRowIndex = null;
  }

  getJurisdictionName(id: number): string {
    const item = this.jurisdictionDropdown.find(j => j.JurisdictionID === id);
    return item ? item.Jurisdiction : '';
  }

  getRegulatorName(id: number): string {
    const item = this.regulatorDropdown.find(r => r.RegulatorID === id);
    return item ? item.RegulatorName : '';
  }

  getDocTypeName(id: number): string {
    const item = this.docTypeDropdown.find(d => d.DocTypeID === id);
    return item ? item.DocTypeName : '';
  }

  cancelEdit(i: number) {
    this.showLoader = true;
    const selectedJurisdiction = this.jurisdictionDropdown.find(
      j => j.JurisdictionID === this.editModelCopy.JurisdictionID
    );
    const selectedRegulator = this.regulatorDropdown.find(
      r => r.RegulatorID === this.editModelCopy.RegulatorID
    );
    const selectedDocType = this.docTypeDropdown.find(
      d => d.DocTypeID === this.editModelCopy.DocTypeID
    );
    this.briefGeniusList[i] = {
      ...this.briefGeniusList[i],
      JurisdictionID: this.editModelCopy.JurisdictionID,
      Jurisdiction: selectedJurisdiction?.Jurisdiction || '',
      RegulatorID: this.editModelCopy.RegulatorID,
      Regulator: selectedRegulator?.RegulatorName || '',
      DocTypeID: this.editModelCopy.DocTypeID,
      DocType: selectedDocType?.DocTypeName || ''
    };
    // this.editModel = {
    //   JurisdictionID: this.editModelCopy.JurisdictionID,
    //   Jurisdiction: this.editModelCopy.Jurisdiction,
    //   RegulatorID: this.editModelCopy.RegulatorID,
    //   Regulator: this.editModelCopy.Regulator,
    //   DocTypeID: this.editModelCopy.DocTypeID,
    //   DocType: this.editModelCopy.DocType
    // };
    this.editRowIndex = null;
    this.showLoader = false;
  }

  private hasActiveFilter(column: string): boolean {
    const key = `active${column}` as keyof typeof this.columnDropdownFilter[0];
    return this.columnDropdownFilter.some(f => !!f[key]);
  }
}